module.exports = __webpack_public_path__ + "static/img/logo-min.845a519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-min.png
// module id = Cwua
// module chunks = 121